import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme';

// Pages
import Home from './pages/Home';
import Login from './pages/Auth/Login';
import AuthCallback from './pages/Auth/AuthCallback';
import Dashboard from './pages/Dashboard';
import CreateEvent from './pages/Event/CreateEvent';
import EventDetail from './pages/Event/EventDetail';
import Upload from './pages/Upload';
import Profile from './pages/Profile/Profile';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Users from './pages/Users'; // Yeni eklenen sayfa
import Messages from './pages/Messages';
import Pricing from './pages/Pricing';
import Participants from './pages/Event/Participants';
import InvitationDesign from './pages/Event/InvitationDesign';
import InvitationPrintPreview from './pages/Event/InvitationPrintPreview';
import PlanSettings from './pages/Admin/PlanSettings';
import SeatingPlan from './pages/SeatingPlan/index';

// Components
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import PrivateRoute from './components/common/PrivateRoute';
import EventTypes from './pages/EventTypes';

// Google Drive API isteklerini optimize etmek için
const optimizeDriveRequests = () => {
  // Görüntü isteklerini önbelleğe almak için
  const originalFetch = window.fetch;
  window.fetch = function (url, options) {
    // Google Drive isteklerini tespit et
    if (typeof url === 'string' &&
      (url.includes('drive.google.com') || url.includes('lh3.googleusercontent.com'))) {
      // Cache-Control başlığı ekle
      options = options || {};
      options.headers = options.headers || {};
      options.headers['Cache-Control'] = 'max-age=3600';
    }
    return originalFetch(url, options);
  };
};

function App() {
  const location = useLocation();
  const isUploadPage = location.pathname.startsWith('/upload/');

  useEffect(() => {
    optimizeDriveRequests();
  }, []);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* Header sadece upload sayfası dışında gösterilir */}
            {!isUploadPage && <Header />}

            <div style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/event/create" element={<PrivateRoute><CreateEvent /></PrivateRoute>} />
                <Route path="/event/:codeHash" element={<EventDetail />} />
                <Route path="/upload/:codeHash" element={<Upload />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/event-types" element={<EventTypes />} />
                <Route path="/event/:codeHash/participants" element={<PrivateRoute><Participants /></PrivateRoute>} />
                <Route path="/event/:codeHash/seating" element={<PrivateRoute><SeatingPlan /></PrivateRoute>} />
                <Route path="/event/:codeHash/invitation-design" element={<PrivateRoute><InvitationDesign /></PrivateRoute>} />
                <Route path="/invitation-print-preview/:codeHash" element={<PrivateRoute><InvitationPrintPreview /></PrivateRoute>} />
                <Route path="/admin/plans" element={<PrivateRoute><PlanSettings /></PrivateRoute>} />
              </Routes>
            </div>

            {/* Footer sadece upload sayfası dışında gösterilir */}
            {!isUploadPage && <Footer />}
          </div>

          <ToastContainer position="top-right" autoClose={3000} />
        </AuthProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}


export default App;
